var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _circle, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 148 148"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 148,
    fill: "var(--color-sidebar-border)",
    rx: 74
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M42.432 120.821s-6.05.02-6.05 6.049c0-6.029-6.049-6.049-6.049-6.049s6.05-.021 6.05-6.05c0 6.029 6.049 6.05 6.049 6.05M90.429 16.152s-6.05.02-6.05 6.049c0-6.029-6.049-6.05-6.049-6.05s6.05-.02 6.05-6.049c0 6.03 6.049 6.05 6.049 6.05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D1D1",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M63.264 103.701h19.17l2.232 16.308H60.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M59.145 103.701h19.17l2.232 16.308H56.781z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    stroke: "#A4A4A4",
    d: "M25.206 38.313a5.04 5.04 0 0 1 5.041-5.041h86.708a5.04 5.04 0 0 1 5.041 5.04v60.494a5.04 5.04 0 0 1-5.041 5.041H30.247a5.04 5.04 0 0 1-5.04-5.04V38.312Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#A4A4A4",
    d: "M19.156 38.313a5.04 5.04 0 0 1 5.041-5.041h86.708a5.04 5.04 0 0 1 5.041 5.04v60.494a5.04 5.04 0 0 1-5.041 5.041H24.197a5.04 5.04 0 0 1-5.04-5.04V38.312Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#A4A4A4",
    d: "M19.156 88.724h90.741a5.04 5.04 0 0 1 5.041 5.041v5.041a5.04 5.04 0 0 1-5.041 5.042h-85.7a5.04 5.04 0 0 1-5.04-5.042z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m45.073 62.292-2.268-2.268m-11.523 0-2.268 2.268m4.957-15.274a8.029 8.029 0 1 1 6.146 14.834 8.029 8.029 0 0 1-6.146-14.834"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M36.793 50.853v4.15l3.262 1.99m-7.513-12.495a3.54 3.54 0 0 0-3.49.89 3.54 3.54 0 0 0-.996 2.986m13.504-3.876a3.54 3.54 0 0 1 3.487.89 3.54 3.54 0 0 1 .998 2.986"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7.855,
    height: 7.855,
    x: 55.724,
    y: 42.998,
    fill: "#EBEBEB",
    rx: 0.981
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 7.855,
    height: 7.855,
    x: 55.724,
    y: 58.365,
    fill: "#EBEBEB",
    rx: 0.981
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 35.342,
    height: 3.805,
    x: 70.212,
    y: 44.569,
    fill: "#EBEBEB",
    rx: 0.981
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 20.752,
    height: 3.805,
    x: 70.212,
    y: 60.564,
    fill: "#EBEBEB",
    rx: 0.981
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 7.855,
    height: 7.855,
    x: 29.222,
    y: 72.501,
    fill: "#EBEBEB",
    rx: 0.981
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 43.636,
    height: 3.805,
    x: 43.998,
    y: 74.527,
    fill: "#EBEBEB",
    rx: 0.981
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67.603,
    cy: 96.359,
    r: 3.44,
    fill: "#fff",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m116.923 123.203-36.704-.023q-.151-.001-.294-.012-.009.009-.018 0c-.115.012-.229.012-.343.012a6.956 6.956 0 0 1-6.954-6.963 6.96 6.96 0 0 1 2.912-5.659 6.9 6.9 0 0 1 4.05-1.296l35.813-4.881c-4.502.742-7.929 4.64-7.932 9.345-.003 5.228 4.236 9.473 9.47 9.477"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m126.401 78.03-.002 35.708c-.004 5.228-4.249 9.468-9.477 9.465-5.234-.003-9.474-4.248-9.47-9.477.002-4.705 3.43-8.603 7.931-9.345l-35.811 4.882a6.9 6.9 0 0 0-4.052 1.295l.001-32.56a4.71 4.71 0 0 1 4.708-4.707l41.47.025a4.705 4.705 0 0 1 4.702 4.714"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m85.782 82.731 7.676 7.649m-.015-7.663-7.648 7.676m23.393-7.705 7.675 7.648m-.013-7.662-7.649 7.676M90.59 98.261l19.866-.036"
  })));
};
export default SvgError;